<template>
  <div class="FilterBoxTransation">
    <el-form :model="ruleForm" ref="ruleForm" @submit.prevent v-on:submit.prevent>
      <div class="viewFilter">
        <el-row :gutter="20">
          <el-col :sm="24" :md="12">
            <el-form-item prop="marketplace_id" label="Marketplace">
              <SelectSearchMarketplace :disabled="$can('2|4|5')" :model="ruleForm.marketplace_id" :isEdit="false" @handleValue="(x) => {$set(ruleForm, 'marketplace_id', x)}" />
            </el-form-item>
          </el-col>
          <el-col :sm="24" :md="12">
            <el-form-item prop="department_store_id" label="Estabelecimento/Documento">
              <SelectSearchDepartamentStore :disabled="$can('5')" :model="ruleForm.department_store_id" :isEdit="false" @handleValue="(x) => {$set(ruleForm, 'department_store_id', x)}" />
            </el-form-item>
          </el-col>
          <el-col :sm="24" :md="12">
            <el-form-item prop="payment_type" label="Tipo de Pagamento">
              <el-select v-model="ruleForm.payment_type" clearable style="width: 100%;">
                <el-option label="Débito" value="debit" />
                <el-option label="Crédito" value="credit" />
              </el-select>
            </el-form-item>
          </el-col>

          <el-col :sm="24" :md="12">
            <el-form-item prop="agent_id" label="Representante">
              <SelectSearchRepresentante :disabled="$can('4|5')" :isEdit="false" @handleValue="(x) => {$set(ruleForm, 'agent_id', x)}" />
            </el-form-item>
          </el-col>
          <el-col :sm="24" :md="12">
            <el-form-item prop="status" label="Status">
              <el-select v-model="ruleForm.status" clearable style="width: 100%;">
                <el-option label="Concluída" value="succeeded" />
                <el-option label="Novo" value="new" />
                <el-option label="Pendente" value="pending" />
                <el-option label="Risco" value="risk" />
                <el-option label="Estorno" value="refunded" />
                <el-option label="Recusou" value="refused" />
                <el-option label="Finalizada" value="finished" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :sm="24" :md="12">
            <el-form-item prop="init_date" label="Período">
              <el-date-picker
                format="dd/MM/yyyy" value-format="yyyy-MM-dd"
                style="width: 100%"
                v-model="ruleForm.init_date"
                type="daterange"
                start-placeholder="Inicio" end-placeholder="Fim">
              </el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row type="flex" class="row-bg" justify="end">
          <el-col :xs="24" :span="15">
            <el-button icon="el-icon-download" @click='searchTable()' type="default" size="large" style="float: right; margin-right: 20px" :disabled="!statusClearFilter">
              Exportar
            </el-button>
            <el-button v-if="statusClearFilter" @click='clearSearch' type="default" size="large" style="float: right; margin-right: 20px">
              Limpar Filtros
            </el-button>
          </el-col>
        </el-row>
      </div>
    </el-form>
  </div>
</template>

<script>
import SelectSearchMarketplace from "@/app/components/Marketplace/SelectSearchMarketplace";
import SelectSearchDepartamentStore from "@/app/components/EstabelecimentoComercial/SelectSearchDepartamentStore";
import SelectSearchRepresentante from "@/app/components/Representante/SelectSearchRepresentante";
import {mapGetters} from "vuex";

export default {
  name: "FilterBoxTransation",
  data () {
    return {
      ruleForm: {
        marketplace_id: null,
        department_store_id: null,
        status: null,
        payment_type: null,
        init_date: null,
        finish_date: null,
        agent_id: null,
        id: null,
      },
      viewFilter: false,
    }
  },
  components: {
    SelectSearchMarketplace,
    SelectSearchDepartamentStore,
    SelectSearchRepresentante,
  },
  props: {
    currentPage: {
      type: Number,
      default: 1
    },
    type: {
      type: Number,
      default: 0
    }
  },
  computed: {
    ...mapGetters('Auth', ['currentUser']),
    statusClearFilter: function () {
      if (this.ruleForm.department_store_id || this.ruleForm.marketplace_id || this.ruleForm.status || this.ruleForm.init_date || this.ruleForm.payment_type || this.ruleForm.agent_id || this.ruleForm.id ) {
        console.log('true')
        return true
      }
      console.log('false')
      return false
    }
  },
  methods: {
    clearSearch () {
      this.viewFilter = false
      this.ruleForm = {
        marketplace_id: null,
        department_store_id: null,
        status: null,
        payment_type: null,
        init_date: null,
        tipo_transaction: null,
        finish_date: null,
        agent_id: null,
        id: null,
      }
      this.$emit('filter', `?page=${this.currentPage}`)
    },
    searchTable () {
      let query = `?page=${this.currentPage}`

      if (this.ruleForm.marketplace_id) {
        query = `${query}&marketplace_id=${this.ruleForm.marketplace_id}`
      }
      if (this.ruleForm.department_store_id) {
        query = `${query}&department_store_id=${this.ruleForm.department_store_id}`
      }
      if (this.ruleForm.status) {
        query = `${query}&status=${this.ruleForm.status}`
      }
      if (this.ruleForm.payment_type) {
        query = `${query}&payment_type=${this.ruleForm.payment_type}`
      }
      if (this.ruleForm.init_date) {
        // 2022-03-29
        query = `${query}&init_date=${this.ruleForm.init_date[0]}&finish_date=${this.ruleForm.init_date[1]}`
      }
      if (this.ruleForm.agent_id) {
        query = `${query}&agent_id=${this.ruleForm.agent_id}`
      }
      if (this.ruleForm.id) {
        query = `${query}&id=${this.ruleForm.id}`
      }
      this.$emit('filterExport', query,this.ruleForm.tipo_transaction)
    }
  },
  async mounted() {
    if (this.$can('2|4|5')) {
      this.ruleForm.marketplace_id = this.currentUser.marketplace_id
    }
    if (this.$can('4')) {
      this.ruleForm.agent_id = this.currentUser.agent_id
    }
    if (this.$can('5')) {
      this.$set(this.ruleForm, 'department_store_id', this.currentUser.department_store_id)
      this.ruleForm.department_store_id = this.currentUser.department_store_id

      this.$set(this.ruleForm, 'marketplace_id', this.currentUser.department_store.marketplace_id)
      this.ruleForm.marketplace_id = this.currentUser.department_store.marketplace_id

      this.$set(this.ruleForm, 'agent_id', this.currentUser.department_store.agent_id)
      this.ruleForm.agent_id = this.currentUser.department_store.agent_id
    }
  }
}
</script>

<style scoped>

</style>
